const TranslationNamespaces = {
  Auth: "auth",
  Dashboard: "dashboard",
};

export default TranslationNamespaces;
